import axios from "./axios"

const url = "/actions"

const fetchErrorMsg = "Error fetching actions:"
const createErrorMsg = "Error creating action:"
const editErrorMsg = "Error updating action:"
const destroyErrorMsg = "Error deleting action:"

const ActionApi = () => {
	const getAll = async () => {
		try {
			const response = await axios.get(url)
			return response.data
		} catch (error) {
			console.error(fetchErrorMsg, error)
			throw error
		}
	}

	const create = async (action) => {
		try {
			const response = await axios.post(url, action)

			return response.data
		} catch (error) {
			console.error(createErrorMsg, error)
			throw error
		}
	}

	const edit = async (id, action) => {
		try {
			const response = await axios.put(`${url}/${id}`, action)

			return response.data
		} catch (error) {
			console.error(editErrorMsg, error)
			throw error
		}
	}

	const destroy = async (id) => {
		try {
			const response = await axios.delete(`${url}/${id}`)

			return response.data
		} catch (error) {
			console.error(destroyErrorMsg, error)
			throw error
		}
	}

	return {
		getAll,
		create,
		edit,
		destroy,
	}
}

export default ActionApi
